<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Remove Feeds/Bundle</ng-container>

    <ng-container dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row">

            <div appCheckPermissionRule
                 [rule]="manageFeedPermissionRule" class="col-12" *ngFor="let feed of form.controls">
                <div [ngClass]="{'mb-3': feed.errors?.length > 0}" class="col-12">
                    <app-checkbox
                        [control]="feed"
                        [formControlName]="feed.name"
                    >
                        <ng-container text>{{ feed.placeholder }}</ng-container>
                    </app-checkbox>
                </div>

            </div>

        </form>
        <form [formGroup]="form.feedBundleFromGroup" class="row">

            <div appCheckPermissionRule
                 [rule]="manageBundlePermissionRule" class="col-12"
                 *ngFor="let feed of form.feedBundleControls">
                <div [ngClass]="{'mb-3': feed.errors?.length > 0}" class="col-12">
                    <app-checkbox
                        [control]="feed"
                        [formControlName]="feed.name"
                    >
                        <ng-container text>{{ feed.placeholder }}</ng-container>
                    </app-checkbox>
                </div>

            </div>

        </form>
    </ng-container>

</app-dialog>
